import React, { forwardRef, useState } from 'react'
import { Controller } from 'react-hook-form'
import { HelperText, TextInput } from 'react-native-paper'
import {
  StyleProp,
  TextInput as TextInputNative,
  View,
  ViewStyle,
  Text,
} from 'react-native'
// @ts-ignore
import getStrength from 'password-strength-calc'
import { mapValueToColor } from '../../../../utils/color'
import { useTranslation } from 'react-i18next'

const mapValueToText = (value: number) => {
  if (value < 20) {
    return 'veryWeak'
  } else if (value < 40) {
    return 'weak'
  } else if (value < 60) {
    return 'moderate'
  } else if (value < 80) {
    return 'strong'
  } else {
    return 'veryStrong'
  }
}
type ControllerTextInputProps = React.ComponentProps<typeof TextInput> & {
  control: any
  name: string
  rules?: any
  error?: any
  showStrength?: boolean
  helperText?: string
  wrapperStyle?: StyleProp<ViewStyle>
}

export const ControlledPasswordInput = forwardRef<
  TextInputNative,
  ControllerTextInputProps
>(
  (
    {
      showStrength,
      wrapperStyle,
      control,
      name,
      rules,
      error,
      helperText,
      ...textInputProps
    },
    ref
  ) => {
    const [hidePass, setHidePass] = useState(true)
    const { t } = useTranslation('login_register_reset')
    return (
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, onBlur, value } }) => {
          const strength = getStrength(value)
          const strengthColor = mapValueToColor(strength)
          const text = t(mapValueToText(strength))
          console.log('strength', strength)
          return (
            <View style={wrapperStyle}>
              <TextInput
                ref={ref}
                onBlur={onBlur}
                onChangeText={onChange}
                value={value}
                {...textInputProps}
                error={error || false}
                right={
                  <TextInput.Icon
                    icon={hidePass ? 'eye' : 'eye-off'}
                    onPress={() => setHidePass(!hidePass)}
                  />
                }
                secureTextEntry={hidePass}
              />
              {showStrength && strength > 0 && (
                <>
                  <View
                    style={{
                      width: strength + '%',
                      borderRadius: 4,
                      height: 4,
                      backgroundColor: strengthColor,
                      position: 'relative',
                      top: -3,
                    }}
                  />
                  <View style={{ alignSelf: 'flex-end' }}>
                    <Text style={{ color: strengthColor }}>{text}</Text>
                  </View>
                </>
              )}
              <HelperText type="error" visible={!!error}>
                {helperText || ' '}
              </HelperText>
            </View>
          )
        }}
      />
    )
  }
)
